import React from 'react'
import FullBlade from '../components/FullBlade'
import CustomerReview from '../components/CustomerReview'
import TheseProperties from '../components/TheseProperties'
import TopDeals from '../components/TopDeals'
import HomeBanner from '../components/HomeBanner'

import HeaderBottom from "../assets/header-bottom-shap.png"
import TabsFlightHotal from '../components/TabsFlightHotal'
import { useTranslation } from 'react-i18next'


const Home = () => {
  const { t } = useTranslation();
  return (
    <div>
        <main className="main position-relative">
          <div className="bottom-main-shap position-absolute top-0">
              <img src={HeaderBottom} alt="" />
          </div>
          <TabsFlightHotal />
          <HomeBanner />
          <div className="trending-destinations-sec mb-md-5 mb-4 mt-md-5 mt-4">
            <div className="container">
              <div className="top-heading d-flex align-items-center justify-content-between gap-2 mb-4">
                <h2 className="m-0">{t("Top deals")}</h2>
                <a href="#" className="text-link">
                  {t("See all")}
                </a>
              </div>
              <TopDeals />   
          </div>
        </div>
          <div className="top-trending-box mb-md-5 mb-4 mt-md-5 mt-4 position-relative">
             <div className="container">
                <div className="top-heading d-flex align-items-center justify-content-between gap-2 mb-4">
                    <h2 className="m-0">{t("Still interested in these properties?")}</h2>
                </div>
                <TheseProperties />
              </div>
          </div>
          <CustomerReview />
        </main>
      <FullBlade />
    </div>
  )
}

export default Home